<template>
  <div class="asm-config">
  
    <employee-dialog v-model="employeeDialogMain" @select="setReviewApprove"></employee-dialog>
    <index-view title="Cài đặt AM-RM & SO-RSO" :filters="filters" :getData="getData" :getDetail="getDetail" :headers="mainHeaders" 
    :detailWidth="1000" :cellSlots="cellSlots" tableKey="storeCode">
      <template #viewSection="{ item, selected }" >
        <!-- <detail :item="item" :selected="selected"></detail> -->
      </template>
      
      <!-- <template #preTitle="{item}">
        
      </template> -->
      
      <template #action1>
      <v-btn color="green darken-4" dark class="rounded-lg" small @click="importDialog=true">Import </v-btn>
      <v-dialog width="600" v-model="importDialog">
        <v-card>
          <v-card-title class="text-subtitle-1">
            Import AM-RM SO-RSO
            <v-spacer></v-spacer> 
            <v-icon color="red" @click="importDialog=false">mdi-close</v-icon>
          </v-card-title>
          <v-card-subtitle>
            <b class="cyan--text text--darken-2">Hướng dẫn upload:</b>
            <ul>
              <li>1. Tải về file <v-btn color="info" small text style="text-transform: none;" @click="templateImport">Template</v-btn></li>
              <li>2. Điền vào 3 cột đánh dấu bắt buộc</li>
              <li>3. Xóa dòng hướng dẫn (bắt buộc,...) ở line số 2</li>
              <li>4. Upload file và chờ hệ thống báo import thành công</li>
            </ul>
          </v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field hide-details label="Tháng" persistent-placeholder outlined dense placeholder="MM/YYYY" v-mask="'##/####'" v-model="importMonth"></v-text-field>
              </v-col>
              
              <v-col cols="12">
                <v-file-input append-icon="" prepend-icon="" persistent-placeholder hide-details label="File" outlined dense 
                placeholder="Chọn file import"
                v-model="importFile"></v-file-input>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="green darken-2" style="text-transform: none;" dark @click="importData">
            <v-icon>mdi-upload</v-icon>
             Import</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </template>
      
    </index-view>
    
  </div>
</template>

<script>

import IndexView from '../../../components/CommonView/IndexView.vue';
import { main, templateImport } from './header'
import { get, importData } from './api'
// import AssignIp from './AssignIp.vue'
import EmployeeDialog from '../../../components/Crud/Prompt/EmployeeDialog.vue';
import * as moment from 'moment/moment';
const statusFilters = ['Tạo mới', 'Hoàn tất', 'Hủy']
export default {
  name: "EmployeeIp",
  components: {
    IndexView,
    EmployeeDialog
  },
  computed: {
    mainHeaders () {
      return main(this.filters)
    },
    yearOptions() {
      let thisYear = moment().year();
      let lowerYear = thisYear - 5;
      let upperYear = thisYear + 5;
      var yearOptions = [];
      for(let y = lowerYear; y <= upperYear; y++) {
        yearOptions.push(y);
      }

      return yearOptions;
    },
    importMonthValue() {
      let date = moment(this.importMonth, "MM/YYYY")
      return date.isValid()
      ? date.format("YYYY-MM-01")
      : null
    }

  },
  data() {
    return {
      filters: [
        {name: 'id', label:'Id', type: 'text', value: '' },
        {name: 'employeeCode', label:'Mã NS', type: 'text', value: '' },
        {name: 'employeeName', label:'Tên NS', type: 'text', value: '' },
        {name: 'type', label:'Phân loại', type: 'select', value: '',
        selectItems: [
          {text: 'AM', value: 'AM' },
          {text: 'RM', value: 'RM' }, 
          {text: 'SO', value: 'SO' }, 
          {text: 'Standard', value: 'STANDARD' },
          {text: 'Exception', value: 'EXCEPTION' },
        ] },
        // {name: 'status', label:'Trạng thái', type: 'select', selectItems: statusFilters, value: '' },
      ],
      cellSlots: ['storeCOde'],
      selected: null,
      action1Dialog: false,
      actionData: {
        month: null
      },
      finals: [],
      sessionYear: moment().year(),

      action2Dialog: false,
      action2Calendar: null,
      readySearch: '',
      readies: [],
      readyLoading: false,

      employeeDialog: false,
      employeeDialogMain: false,

      importMonth: moment().startOf('month').format('MM/YYYY'),
      importFile: null,
      importDialog: false,
    }
  },
  watch: {
    action2Calendar(newVal) {
      this.getReady();
    },
    sessionYear(newVal) {
      this.getFinalSession();
    },
    importDialog(val) {
      if(!val) {
        this.importFile = null
        this.importMonth = null
      }
    }
  },
  methods: {
    importData() {
      if(!this.importMonthValue) {
        alert("no month") 
        return
      }
      if(!this.importFile) {
        alert("no file") 
        return
      }
      let payload = new FormData();
      payload.append('files', this.importFile)
      return importData(this.importMonthValue, payload)
    },
    getData: get,
    // getDetail: getDetailByEmployee,
    actionSubmit(item) {
      return setFinal(item.month).then(() =>{
        // this.action1Dialog = false;
      }).finally(() => {
        this.getFinalSession();
      })
    },
    templateImport: templateImport,
    actionRemove(item) {
      return removeFinal(item.month).then(() => {
        this.finals = this.finals.filter(i => i.month !== item.month)
      }).finally(() => {
        this.getFinalSession();
      })
    },
    getFinal() {
      return getFinal().then(data => {
        this.finals = data.data.map(item => {
          item.month = this.$formatter.formatDate(item.month, 'MM/YYYY')
          return item
        });
      })
    },

    getFinalSession() {
      return getFinalSession(this.sessionYear).then(data => {
        this.finals = data.data.map(item => {
          item.month = this.$formatter.formatDate(item.month, 'MM/YYYY')
          return item
        });
      })
    },

    //ready section
    getReady() {
      this.readyLoading =true
      return getReady(this.action2Calendar).then(data => {
        this.readies = data.data;
      }).finally(() => {
        this.readyLoading =false
      })
    },
    
    setReady() {
      //call api to set ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return setReady(this.action2Calendar).then(() => {
        this.getReady();
      })
    },
    setEmployee(value) {
      var empObj = value[0]
      if(value.length == 0) {
        return changeConfirmedBy(this.selected.id, '').then(() => {
          this.selected.smCode = ''
          this.selected.smName = ''
          this.employeeDialog = false
        }).finally(() => {
          this.selected = null
        })
      }else {
        return changeConfirmedBy(this.selected.id, empObj.code).then(() => {
          this.selected.smCode = empObj.code
          this.selected.smName = empObj.name
          this.employeeDialog = false
        }).finally(() => {
          this.selected = null
        })
      }
    },
    setReviewApprove(value) {
      var empObj = value[0]
      if(value.length == 0) {
        return changeApprovedBy(this.selected.id, null).then(() => {
            this.selected.approvedByCode = null
            this.selected.approvedByName = null
            this.employeeDialogMain = false
          }).finally(() => {
            this.selected = null
          })
      }else {
        return changeApprovedBy(this.selected.id, empObj.code).then(() => {
          this.selected.approvedByCode = empObj.code
          this.selected.approvedByName = empObj.name
          this.employeeDialogMain = false
        }).finally(() => {
          this.selected = null
        })
      }
    },
    
    initReady() {
      //call api to set ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return initReady(this.action2Calendar).then(() => {
        this.getReady();
      })
    },

    generateReview() {
      //call api to generate review for ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return generateReview(this.action2Calendar).then(() => {
        this.getReady();
      })
    },
    convertStatus(status) {
      if(status === 0) return {text:'Tạo mới', color:'cyan--text'}
      if(status === 1) return {text:'SM duyệt', color:'green--text'}
      if(status === 2) return {text:'Lưu trữ', color:'blue--text'}
      return {text:'Hủy', color:'red--text'}
    }
  },
  mounted() {

  }
}
</script>